import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { IUser } from '../../../shared/models';
import { PaymentV2Service, StorageService, UtilService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  @Output() public viewportEmit = new EventEmitter();
  @ViewChild('paymentTemplate', { static: true }) public paymentTemplate;

  isMobile;
  isIos;
  currency;
  public userdata: IUser;
  eventsSubject = new Subject<any>();
  isBannerCLicked = false;
  infoText = [
    { text: '<strong>Pause or cancel</strong> subscription anytime' },
    { text: '<strong>Select fundraisers</strong> to support monthly' },
    { text: 'Receive <strong>regular updates</strong>' },
    { text: '<strong>100% refund</strong> on cancellation' }
  ];

  nudgeText = [
    { head: '', text: 'Help 1 critical life every month with this donation' },
    { head: '', text: 'Help 2 critical lives every month with this donation' },
    { head: '', text: 'Help 3 critical lives every month with this donation' }
  ];

  constructor(
    public util: UtilService,
    public variablesService: VariablesService,
    public dialog: MatDialog,
    public paymentV2: PaymentV2Service,
    private storage: StorageService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util.isMobile();
    this.isIos = this.util.isIOSDevice();
    this.variablesService.userData.subscribe(res => this.userdata = res);
    this.util.currency.subscribe((currency) => {
      this.currency = currency;
      if (currency) {
        setTimeout(() => {
          this.openDialog(this.paymentTemplate);
        }, 200);
      }
    });
  }

  openDialog(template) {
    this.dialog.open(template, {
      width: this.util.isMobile() ? '100vw' : '736px',
      maxWidth: '100%',
      panelClass: 'payment-sip-dialog',
      closeOnNavigation: false,
      disableClose: true
    });
  }

  bannerClickList() {
    const user = this.storage.get('user');
    if (!user && this.util.isMobile() && !this.isBannerCLicked) {
      this.eventsSubject.next(null);
      this.isBannerCLicked = true;
    }
  }

  close() {
    this.dialog.closeAll();
  }

  viewport(e) {
    this.viewportEmit.emit(e);
  }
}
